import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { LanguageProvider } from './i18n/LanguageContext';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/Home';
import RSVP from './pages/RSVP';
import Guestbook from './pages/Guestbook';
import Admin from './pages/Admin';
import Privacy from './pages/Privacy';
import Hotels from './pages/Hotels';
import Erlangen from './pages/Erlangen';

export default function App() {
  return (
    <LanguageProvider>
      <BrowserRouter>
        {/* Fixed navbar — content needs padding-top to avoid overlap */}
        <Navbar />

        {/* Main content area offset by navbar height */}
        <main style={{ paddingTop: '70px', minHeight: '100vh' }}>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/rsvp" element={<RSVP />} />
            <Route path="/guestbook" element={<Guestbook />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/hotels" element={<Hotels />} />
            <Route path="/erlangen" element={<Erlangen />} />
          </Routes>
        </main>

        <Footer />
      </BrowserRouter>
    </LanguageProvider>
  );
}
